const text = `## Real-time Availability Implementation

### PRE-REQUISITES
1. Create a Halo for Developers account (developer account).
2. Create a license (API keys) and setup callback URLs for required events.
`;

export default text;



// WEBPACK FOOTER //
// ./src/components/guides/RealTimeAvailability/RealTimeAvailabilityText2.js